var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-6M",
                    defaultEnd: "6M",
                    label: "(기간)조치완료일",
                    name: "actionCompleteDates",
                  },
                  model: {
                    value: _vm.searchParam.actionCompleteDates,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "actionCompleteDates", $$v)
                    },
                    expression: "searchParam.actionCompleteDates",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    codeGroupCd: "IBM_TASK_TYPE_CD",
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "ibmTaskTypeCd",
                    label: "업무",
                  },
                  model: {
                    value: _vm.searchParam.ibmTaskTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "ibmTaskTypeCd", $$v)
                    },
                    expression: "searchParam.ibmTaskTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    stepperGrpCd: "IBM_SUPPLE_STEP_CD",
                    type: "search",
                    itemText: "stepperMstNm",
                    itemValue: "stepperMstCd",
                    name: "ibmSuppleStepCd",
                    label: "보완진행단계",
                  },
                  model: {
                    value: _vm.searchParam.ibmSuppleStepCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "ibmSuppleStepCd", $$v)
                    },
                    expression: "searchParam.ibmSuppleStepCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-dept", {
                  attrs: {
                    isFirstValue: false,
                    type: "search",
                    label: "요청부서",
                    name: "improveRequestDeptCd",
                  },
                  model: {
                    value: _vm.searchParam.improveRequestDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "improveRequestDeptCd", $$v)
                    },
                    expression: "searchParam.improveRequestDeptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-dept", {
                  attrs: {
                    type: "search",
                    label: "보완부서",
                    name: "actionDeptCd",
                  },
                  model: {
                    value: _vm.searchParam.actionDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "actionDeptCd", $$v)
                    },
                    expression: "searchParam.actionDeptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-checkbox", {
                  attrs: {
                    isFlag: true,
                    falseLabel: "All",
                    label: "보완필요 업무 확인",
                    name: "suppleFlag",
                  },
                  model: {
                    value: _vm.searchParam.suppleFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "suppleFlag", $$v)
                    },
                    expression: "searchParam.suppleFlag",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("q-table", {
        attrs: {
          grid: "",
          title: "",
          data: _vm.grid.data,
          columns: _vm.grid.columns,
          "hide-header": "",
          "hide-bottom": "",
          "rows-per-page-options": [0],
          "virtual-scroll": "",
        },
        scopedSlots: _vm._u([
          {
            key: "top-right",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "item",
            fn: function (props) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3",
                  },
                  [
                    _c(
                      "q-card",
                      {
                        staticClass: "mobileTableCardLayer",
                        on: {
                          click: function ($event) {
                            return _vm.linkClick(props.row)
                          },
                        },
                      },
                      [
                        _c(
                          "q-card-section",
                          {
                            staticClass: "bg-grey-2",
                            attrs: { horizontal: "" },
                          },
                          [
                            _c("q-card-section", { staticClass: "q-pt-xs" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-grid-title q-mt-sm q-mb-xs",
                                },
                                [
                                  _vm._v(
                                    "[" +
                                      _vm._s(props.row.ibmTaskTypeName) +
                                      "] " +
                                      _vm._s(props.row.ibmTitle)
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "q-card-section",
                          { staticClass: "grid-card-etc" },
                          [
                            props.row.suppleFlag === "Y"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "text-grid-etc-title" },
                                    [_vm._v(" 보완완료 요청일 : ")]
                                  ),
                                  _c("div", { staticClass: "text-grid-etc" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.row.suppleScheduleDate) +
                                        " "
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                class: [
                                  "text-grid-etc",
                                  _vm.getColorStatus(props.row.ibmSuppleStepCd),
                                ],
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.row.ibmSuppleStepName ||
                                        props.row.suppleFlagName
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm.grid.data.length === 0
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" },
            [
              _c(
                "q-card",
                { staticClass: "mobileTableCardLayer" },
                [
                  _c(
                    "q-card-section",
                    {
                      staticClass: "bg-grey-2 text-center",
                      attrs: { horizontal: "" },
                    },
                    [
                      _c("q-card-section", { staticClass: "q-pt-xs" }, [
                        _c(
                          "div",
                          { staticClass: "text-grid-title q-mt-sm q-mb-xs" },
                          [_vm._v("데이터가 존재하지 않습니다.")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }